import { string } from "prop-types";
import {
  PrivacyTerms,
  SsnByItalianCustomerDetails,
} from "./../../@types/DTO/ApiResponses";
import { SelectedVehicleDetails } from "./../../@types/Booking/SelectedVehicleDetails.d";
import {
  OptionInVehicle,
  Vehicle,
  FilterListResponse,
} from "./../../@types/DTO/Vehicles.d";
import countryList from "../responses/CountryList.json";
import { PaymentBodyForScalapay } from "../../@types/DTO/AllPaymentMethods";
import { CreateNewBooking, UserLoginResponse } from "../../@types/DTO/Booking";
import {
  CustomerDetailsResponse,
  CustomerDetailsResponse_2,
  DocumentUploadResponse,
  InsuranceDetails,
  ItalianCustomerDetailsUsingSSNResponse,
} from "../../@types/DTO/ApiResponses";
import axios, { AxiosInstance, AxiosResponse } from "axios";
import CryptoJS from "crypto-js";
import { BookingDetails } from "./../../@types/Booking/bookingDetails.d";
import { DetailsFormValues } from "../../components/Layouts/WebCheckInForms/WebCheckInForms.props";
import { Affiliate, Location } from "../../@types/DTO/Locations";
import { PrivacyPolicy } from "../../@types/DTO/privacyPolicy";
import { StateResponse } from "../../@types/DTO/LocationRequests";
import { BookingSourceResponse } from "../../@types/DTO/BookingSource";
import {
  AllPaymentMethodsResponse,
  NewPaymentsMethods,
  PaymentLinkResponse,
} from "../../@types/DTO/AllPaymentMethods";
import { ReservationSuccessfullResponse } from "../../@types/DTO/ReservationDetails";
import { AppSettingResponse } from "../../@types/DTO/AppSetting";
import { companyDetails } from "../../@types/Booking/companyDetails";
import * as DateFns from "date-fns";
import { format } from "date-fns";
import { MacroClassGroup } from "../../@types/DTO/MacroClass";
import i18n from "../../config/i18n";
import { BookingStateRedux } from "../../store/onlineBooking/states";
import { NexiChargeTransactionDetails } from "../../@types/Booking/nexiTransactionDetails";
import { StripeTransactionDetails } from "../../@types/Booking/stripeTransactionDetails";
import { ChosenOptions } from "../../components/Layouts/BookingVehicleInfoCard/BookingVehicleInfoCard.props";
import bcrypt from "bcryptjs";
import { useState } from "react";
import { normalizeGender } from "../../helpers/normalizeGender";

class BookingApi {
  allReservationSources: BookingSourceResponse[] = [];
  MacroClassList: MacroClassGroup[] = [];
  public bookingApiRequestInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL_2,
  });
  constructor() {
    // this.getAllCountries();
    this.getStates("ITALIA");
  }

  private token_value = "mercedes_dogma_23031508$_mbrent_@#99907$$";

  private encryptToken = (token) => {
    const secretKey = "$h7kh#";
    return CryptoJS.AES.encrypt(token, secretKey).toString();
  };

  private encryptLoginPayload = (value: string): string => {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    if (!secretKey) {
      return value;
    }
    return CryptoJS.AES.encrypt(value, secretKey).toString();
  };
  getAllReservationSources(
    selectedAffiliate: string
  ): Promise<BookingSourceResponse[]> {
    if (!selectedAffiliate) {
      if (this.allReservationSources.length) {
        return Promise.resolve(this.allReservationSources);
      }
    }
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance
      .get<BookingSourceResponse[]>(
        `/settings/channels?language=${i18n.language}&affiliate=${selectedAffiliate}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        this.allReservationSources = e.data;
        return e.data;
      });
  }

  async getReservationSourcesOnStartAndEndDate(
    startDate: string,
    endDate: string,
    locationLang: string,
    startTime: string,
    endTime: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance
      .get(
        `/settings/reservationSourcesOnDates?startDate=${startDate}&endDate=${endDate}&startTime=${startTime}&endTime=${endTime}&lang=${locationLang}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  getAllMacroReservationSources(
    selectedMacroGroup: string
  ): Promise<BookingSourceResponse[]> {
    if (!selectedMacroGroup) {
      if (this.allReservationSources.length) {
        return Promise.resolve(this.allReservationSources);
      }
    }
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance
      .get<BookingSourceResponse[]>(
        `/settings/channels?language=${i18n.language}&macroDescription=${selectedMacroGroup}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        this.allReservationSources = e.data;
        return e.data;
      });
  }
  getAllMacroGroups(): Promise<MacroClassGroup[]> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance
      .get<MacroClassGroup[]>("/reservations/macroClassList", {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      })
      .then((e) => {
        return e.data;
      });
  }

  getBookingDetailsByVoucherCode(
    reservationVoucher: string,
    firstName: string,
    lastName: string,
    companyName: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<CreateNewBooking>(
      process.env.REACT_APP_SERVER_URL_2 + "/reservations/by/voucher",
      {
        reservationVoucher: reservationVoucher,
        customerFirstName: firstName,
        customerLastName: lastName,
        companyName: companyName,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  getReservationVehicles(bookingDetails: BookingDetails) {
    if (
      !bookingDetails?.pickUpDateAndTime ||
      !bookingDetails?.dropOffDateAndTime == null
    ) {
      return Promise.reject("Dates not found");
    }
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post(
      process.env.REACT_APP_SERVER_URL_2 +
        "/reservations/touroperator/quotations",
      {
        endDate:
          DateFns.format(bookingDetails.dropOffDateAndTime, "yyyy-MM-dd") +
          "T" +
          DateFns.format(bookingDetails.dropOffDateAndTime, "HH:mm:ss"),
        startDate:
          DateFns.format(bookingDetails.pickUpDateAndTime, "yyyy-MM-dd") +
          "T" +
          DateFns.format(bookingDetails.pickUpDateAndTime, "HH:mm:ss"),
        age: 25,
        isYoungDriverAge: bookingDetails.isYoungDriverAge,
        isYoungDriver2Age: bookingDetails.isYoungDriver2Age,
        isSeniorDriverAge: bookingDetails.isSeniorDriverAge,
        noFeeAge: bookingDetails.noFeeAge,
        pickUpLocation: bookingDetails.pickUpLocationDetails.code,
        dropOffLocation: bookingDetails.dropOffLocationDetails.code,
        showPics: bookingDetails.showPics,
        showOptionalImage: bookingDetails.showOptionalImage,
        showVehicleParameter: bookingDetails.showVehicleParameter,
        showVehicleExtraImage: bookingDetails.showVehicleExtraImage,
        showBookingDiscount: bookingDetails.showBookingDiscount,
        agreementCoupon: bookingDetails.agreementCoupon,
        macroGroupName: bookingDetails.macroGroupName,
        homeDeliveryAddress: bookingDetails.homeDeliverySelected
          ? bookingDetails.homeDeliveryAddress || undefined
          : undefined,
        homeDeliveryAddressKm: bookingDetails.homeDeliverySelected
          ? bookingDetails.homeDeliveryAddressKm ?? undefined
          : undefined,
        homeReturnAddress: bookingDetails.homeReturnSelected
          ? bookingDetails.homeReturnAddress || undefined
          : undefined,
        homeReturnAddressKm: bookingDetails.homeReturnSelected
          ? bookingDetails.homeReturnAddressKm ?? undefined
          : undefined,
        bookingChannel:
          bookingDetails.reservationSource != null
            ? bookingDetails.reservationSource.code
            : "WEB001",
        language: i18n.language,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  getBookingDetailsByBookingDateAndReservationCode(
    reservationPrefix: string,
    reservationNumber: string,
    reservationDate: Date
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<CreateNewBooking>(
      process.env.REACT_APP_SERVER_URL_2 + "/reservations/by/number",
      {
        reservationDate:
          DateFns.format(reservationDate, "yyyy-MM-dd") +
          "T" +
          DateFns.format(reservationDate, "HH:mm:ss"),
        reservationPrefix,
        reservationNumber: parseInt(reservationNumber),
        showAdditionalDriverFee: true,
        fetchDocumentTypes: "true",
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  registerNewUser(e) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<CreateNewBooking>(
      process.env.REACT_APP_SERVER_URL_2 + "/customer/register",
      {
        firstName: e.firstName,
        middleName: e.middleName,
        lastName: e.lastName,
        companyName: e.companyName,
        mobileNumber: e.mobileNumber,
        email: e.email,
        country: e.country,
        state: e.state,
        city: e.city,
        streetName: e.streetName,
        streetNumber: e.streetNumber,
        Zip: e.zip,
        vatNumber: e.vatNumber,
        ssnNumber: e.ssnNumber,
        sex: e.sex,
        telephone: e.telephone,
        birthDate: e.birthDate,
        birthPlace: e.birthPlace,
        birthProvidence: e.birthProvince,
        birthNation: e.birthNation,
        isDriver: e.isDriver,
        licence: e.license,
        issuedBy: e.issuedBy,
        licenceType: e.licenseType,
        documentIssueDate: e.documentIssueDate,
        documentExpiryDate: e.documentExpiryDate,
        documentNumber: e.documentNumber,
        document: e.document,
        customerId: e.customerId,
        customerType: e.customerType,
        password: e.password,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  onlineUserAuthentication(
    //missing in proxy server
    email: string,
    password: string
  ): Promise<AxiosResponse<UserLoginResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post<UserLoginResponse>(
      process.env.REACT_APP_SERVER_URL_2 + "/customer/login",
      {
        email,
        password,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  addDrivers(
    reservationId: number,
    driverDetails: [DetailsFormValues, DetailsFormValues, DetailsFormValues],
    country?: Array<{ EN: string; IT: string; SELECT: string }>
  ): Promise<AxiosResponse<CustomerDetailsResponse_2>[]> {
    const driverDetails_filtered = driverDetails
      .map((e) => {
        if (!e) {
          return;
        }
        const temp = { ...e };
        for (const i of Object.keys(temp)) {
          if (!temp[i]) {
            delete temp[i];
          }
          if (i == "customerDocs") {
            delete temp[i];
          }
        }
        let sourceList;
        if (country && country.length > 0) {
          sourceList = country;
        } else if (
          countryList &&
          countryList.country &&
          countryList.country.length > 0
        ) {
          sourceList = countryList.country;
        } else {
          sourceList = [];
        }

        const selectedCountry = sourceList.find(
          (item) => item.EN == temp.country || item.IT == temp.country
        );

        if (selectedCountry) {
          temp.country = selectedCountry.SELECT;
        }

        return {
          ...temp,
          zip: temp.zip?.toString() || "",
          isDriver: temp.isDriver.toLowerCase() == "yes",
          customerType: temp.customerType.toUpperCase(),
          issuedBy: temp.issueBy || "",
        };
      })
      .filter((temp) => {
        return !!temp;
      });
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .post(
        process.env.REACT_APP_SERVER_URL_2 +
          "/driver/add/reservation/" +
          reservationId,
        {
          driverDetails: driverDetails_filtered,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        e.data.map((e: CustomerDetailsResponse_2, index) => {
          if (
            (driverDetails_filtered[index]?.identificationDocuments &&
              driverDetails_filtered[index]?.identificationDocuments?.length) ||
            (driverDetails_filtered[index]?.drivingLicenseDocuments &&
              driverDetails_filtered[index]?.drivingLicenseDocuments?.length)
          ) {
            const formData = new FormData();
            driverDetails_filtered[index]?.identificationDocuments.forEach(
              (el) => formData.append("idDoc", el)
            );
            driverDetails_filtered[index]?.drivingLicenseDocuments.forEach(
              (el) => formData.append("driverLicenseDocument", el)
            );

            this.bookingApiRequestInstance
              .post(
                `${process.env.REACT_APP_SERVER_URL_2}/driver/upload-documents-vrent/${e.customerId}`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${hashedToken}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
                  },
                  withCredentials: true,
                }
              )
              .then((response) => {
                console.log("Documents uploaded successfully:", response.data);
              })
              .catch((error) => {
                console.error("Error uploading documents:", error);
                throw error;
              });
          }
        });
        return e.data;
      });
  }

  addDocuments(
    customerId: number,
    documents: Array<File>,
    driverLicensedocument: Array<File>
  ): Promise<AxiosResponse<DocumentUploadResponse>> {
    const formData = new FormData();
    const hashedToken = this.encryptToken(this.token_value);
    documents.forEach((el) => formData.append("idDoc", el));
    driverLicensedocument.forEach((el) =>
      formData.append("driverLicenseDocument", el)
    );
    try {
      const response = axios.put<DocumentUploadResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/documents/${customerId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Content-Type": "multipart/form-data",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error uploading documents:", error);
      throw error;
    }
  }

  async getCustomerDetails(
    customerId: number
  ): Promise<AxiosResponse<CustomerDetailsResponse_2>> {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<CustomerDetailsResponse_2>(
        process.env.REACT_APP_SERVER_URL_2 + "/customer/" + customerId,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((response) => {
        const { reservationVoucher, ...rest } = response.data as any;
        response.data = { ...rest, documents: [] };
        return response;
      });
  }

  async updateCustomerDetails(
    customerId: number,
    customerDetails: DetailsFormValues
  ): Promise<AxiosResponse<CustomerDetailsResponse>> {
    const { reservationVoucher, ...safeCustomerDetails } = customerDetails;
    // Format and continue with safe values
    const temp = formatUserDetails(safeCustomerDetails);

    if ("issueBy" in temp) {
      if (!temp.issuedBy && temp.issueBy) {
        temp.issuedBy = temp.issueBy;
      }
      delete temp.issueBy;
    }
    const hashedToken = this.encryptToken(this.token_value);
    const headers = {
      Authorization: `Bearer ${hashedToken}`,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
      "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
    };
    try {
      const customerDetails =
        await this.bookingApiRequestInstance.put<CustomerDetailsResponse>(
          `${process.env.REACT_APP_SERVER_URL_2}/customer/${customerId}`,

          {
            ...temp,
            // zip: temp.zip.toString() || "",
            isDriver: temp.isDriver?.toLowerCase() === "yes",
            customerType: temp.customerType?.toUpperCase(),
          },
          {
            headers,
            withCredentials: true,
          }
        );
      return customerDetails;
    } catch (error) {
      console.error("Error updating customer details:", error);
      throw error;
    }
  }

  async getCity(cityName): Promise<AxiosResponse<StateResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<StateResponse>(
      process.env.REACT_APP_SERVER_URL_2 +
        "/locations/city/" +
        cityName +
        "/state_and_zip/all",
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  async getStates(countryName = "", country): Promise<AxiosResponse<string[]>> {
    const hashedToken = this.encryptToken(this.token_value);

    let sourceList;
    if (country && country.length > 0) {
      sourceList = country;
    } else if (
      countryList &&
      countryList.country &&
      countryList.country.length > 0
    ) {
      sourceList = countryList.country;
    } else {
      sourceList = [];
    }
    const selectedCountry = sourceList.find((item) => {
      return item.EN === countryName || item.IT === countryName;
    });
    // If found, update countryName to its SELECT value
    if (selectedCountry) {
      countryName = selectedCountry.SELECT;
    }
    if (countryName != "") {
      const resCity = this.bookingApiRequestInstance.get<string[]>(
        process.env.REACT_APP_SERVER_URL_2 +
          "/locations/country/" +
          countryName +
          "/cities/all",
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      );
      const resState = await resCity?.then((response) => {
        response.data = response.data?.sort() || [];
        return response;
      });
      return resState;
    } else {
      const emptyCity: string[] = [];
      const emptyResponse: AxiosResponse<string[]> = {
        data: emptyCity,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
      };
      return Promise.resolve(emptyResponse);
    }
  }
  async getReservationLocations(
    selectedAffiliateId = ""
  ): Promise<AxiosResponse<Location[]>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<Location[]>(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/locations/all/?selectedAffiliate=${selectedAffiliateId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async getAffiliate(): Promise<AxiosResponse<Affiliate[]>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<Affiliate[]>(
      process.env.REACT_APP_SERVER_URL_2 + "/reservations/affiliate/all/",
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  // async getAllCountries(): Promise<AxiosResponse<string[]>> {
  //   const hashedToken = this.encryptToken(this.token_value);
  //   // return this.bookingApiRequestInstance.get<string[]>(
  //   //   // process.env.REACT_APP_SERVER_URL_2 + "/locations/country/all",
  //   //   process.env.REACT_APP_SERVER_URL_2 + "../responses/countryList.json",
  //
  //   //   {
  //   //     headers: {
  //   //       Authorization: `Bearer ${hashedToken}`,
  //   //       "Cache-Control": "no-cache",
  //   //       Pragma: "no-cache",
  //   //       Expires: "0",
  //   //       "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
  //   //     },
  //   //     withCredentials: true,
  //   //   }
  //   // );
  //   return Promise.resolve({
  //     data: countryList.country.map((item) => {
  //       if (i18n.language.toLowerCase() === "en") {
  //         return item.EN;
  //       } else if (i18n.language.toLowerCase() === "it") {
  //         return item.IT;
  //       } else {
  //         return item.SELECT;
  //       }
  //     }),
  //     status: 200,
  //     statusText: "OK",
  //   });
  // }
  async getAllCountries(
    country?: Array<{ EN: string; IT: string; SELECT: string }>
  ): Promise<AxiosResponse<string[]>> {
    const lang = i18n.language.toLowerCase();

    if (country && country.length > 0) {
      console.log("country", country);
      const data = country.map((item) => {
        if (lang === "en") return item.EN;
        if (lang === "it") return item.IT;
        return item.SELECT;
      });
      return Promise.resolve({
        data,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
      });
    }

    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<string[]>(
      process.env.REACT_APP_SERVER_URL_2 + "/locations/country/all",
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async getItalianCustomerDetailsBySSN(
    ssn: string
  ): Promise<AxiosResponse<ItalianCustomerDetailsUsingSSNResponse>> {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get<ItalianCustomerDetailsUsingSSNResponse>(
      process.env.REACT_APP_SERVER_URL_2 + "/customer/details/by/ssn/" + ssn,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  async getSsnByCustomerDetails(
    firstName: string,
    lastName: string,
    birthNation: string,
    birthPlace: string,
    sex?: string,
    dob?: Date,
    country?: string
  ): Promise<AxiosResponse<SsnByItalianCustomerDetails>> {
    // sex and dob are required by the API — skip the call if either is missing
    if (!sex || !dob) {
      return Promise.resolve({ data: "" } as any);
    }

    const currentTime = new Date();
    const dobDatePart = new Date(dob);
    dobDatePart.setHours(currentTime.getHours());
    dobDatePart.setMinutes(currentTime.getMinutes());
    dobDatePart.setSeconds(currentTime.getSeconds());
    dobDatePart.setMilliseconds(currentTime.getMilliseconds());
    const hashedToken = this.encryptToken(this.token_value);

    return await this.bookingApiRequestInstance.post<SsnByItalianCustomerDetails>(
      process.env.REACT_APP_SERVER_URL_2 + "/customer/details_by_ssn",
      {
        firstName,
        lastName,
        birthNation: birthNation,
        birthPlace: birthPlace,
        sex: normalizeGender(sex),
        dob: new Date(dobDatePart).toISOString(),
        national: country,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async getPrivacyPolicy(
    reservationId?: number | null,
    callFrom?: string
  ): Promise<AxiosResponse<PrivacyPolicy>> {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get<PrivacyPolicy>(
      process.env.REACT_APP_SERVER_URL_2 +
        "/reservations/privacy-policy/" +
        reservationId +
        "/" +
        callFrom,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  async savePrivacyPolicy(
    reservationId: number,
    acceptedPolicies: number[]
  ): Promise<AxiosResponse<PrivacyPolicy>> {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.post<PrivacyPolicy>(
      process.env.REACT_APP_SERVER_URL_2 +
        "/reservations/privacy-policy/" +
        reservationId,
      {
        acceptedPrivacyPolicies: acceptedPolicies,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async createBooking(
    firstName: string,
    lastName: string,
    email: string,
    phoneNo: string,
    reservationInfo: BookingDetails,
    customerInfo: DetailsFormValues,
    vehicleInfo: Vehicle,
    paymentInfo: SelectedVehicleDetails,
    paymentMethod: string,
    CompanyInfo: companyDetails,
    userId: string | undefined,
    onRequest: string | undefined,
    CustomerType: string | undefined,
    isInvoiceToCompanySelected: boolean | undefined,
    payWiretransfer: string | undefined,
    payVpos: string | undefined,
    selectedInsurance: string | undefined,
    extrasSelected: ChosenOptions["options"],
    extrasPrice: number,
    country?: [],
    paymentTypeCompanyDetails?: string | undefined,
    hideNumberOfFieldsAtPayAtDesk?: boolean,
    enableCreditCardDeferredPayment?: boolean
  ): Promise<AxiosResponse<ReservationSuccessfullResponse> | string> {
    const isValidSSN = await this.validateSSNField(
      customerInfo,
      firstName || customerInfo.firstName,
      lastName || customerInfo.lastName,
      country,
      paymentTypeCompanyDetails,
      hideNumberOfFieldsAtPayAtDesk
    );
    let isValidCompanySSN = "true";
    let companySSn = "";
    if (
      // isInvoiceToCompanySelected != undefined &&
      // isInvoiceToCompanySelected == true &&
      CustomerType != undefined &&
      CustomerType != "" &&
      CustomerType == "Individual"
    ) {
      companySSn = document.getElementsByName("CompanySSNNumber")[0]?.value;
      isValidCompanySSN = await this.validateSSNFieldForCompany(
        CompanyInfo,
        companySSn,
        paymentTypeCompanyDetails,
        hideNumberOfFieldsAtPayAtDesk
      );
    }
    const hashedToken = this.encryptToken(this.token_value);

    if (isValidSSN == "true" && isValidCompanySSN == "true") {
      const currentTime = new Date();
      let companyDOB;
      if (CompanyInfo.birthDate) {
        companyDOB = new Date(CompanyInfo.birthDate.toString());
        companyDOB.setHours(currentTime.getHours());
        companyDOB.setMinutes(currentTime.getMinutes());
        companyDOB.setSeconds(currentTime.getSeconds());
        companyDOB.setMilliseconds(currentTime.getMilliseconds());
      }

      let customerDOB;
      if (customerInfo.dateOfBirth) {
        customerDOB = new Date(customerInfo.dateOfBirth.toString());
        customerDOB.setHours(currentTime.getHours());
        customerDOB.setMinutes(currentTime.getMinutes());
        customerDOB.setSeconds(currentTime.getSeconds());
        customerDOB.setMilliseconds(currentTime.getMilliseconds());
      }
      // const updatedCustomerInfo = { ...customerInfo };
      const clientId = "";

      const updatedCustomerInfo = {
        ...customerInfo,
        clientId: clientId,
      };

      let sourceList;
      if (country && country.length > 0) {
        sourceList = country;
      } else if (
        countryList &&
        countryList.country &&
        countryList.country.length > 0
      ) {
        sourceList = countryList.country;
      } else {
        sourceList = [];
      }
      const selectedCountry = sourceList.find(
        (item) =>
          item?.EN === customerInfo.country || item?.IT === customerInfo.country
      );

      const selectedBirthNation = sourceList.find(
        (item) =>
          item.EN === customerInfo.birthNation ||
          item.IT === customerInfo.birthNation
      );
      // If found, update countryName to its SELECT value
      if (selectedCountry) {
        updatedCustomerInfo.country = selectedCountry?.SELECT;
      }
      if (selectedBirthNation) {
        updatedCustomerInfo.birthNation = selectedBirthNation?.SELECT;
      }
      // Normalize gender before building customerInfo — the form holds the
      // translated label, and the proxy only accepts canonical values.
      const normalizedSex = normalizeGender(updatedCustomerInfo?.sex);
      if (normalizedSex) {
        updatedCustomerInfo.sex = normalizedSex;
      }

      if (await this.validateVATNumber(CompanyInfo)) {
        return this.bookingApiRequestInstance.post<ReservationSuccessfullResponse>(
          process.env.REACT_APP_SERVER_URL_2 +
            "/reservations/touroperator/bookings",
          {
            isDiscounted: paymentInfo.isDiscounted,
            isPayLaterFee: paymentInfo.isPayLaterFee,
            payLaterFeeAmt: paymentInfo.payLaterFeeAmt,
            surchargeAmt: paymentInfo.surchargeAmt ?? "0",
            agreementCoupon: reservationInfo.agreementCoupon,
            discountValueWithoutVat: vehicleInfo?.Reference?.ID_without_vat
              ? vehicleInfo?.Reference?.ID_without_vat?.toString()
              : (
                  vehicleInfo.Reference.originalAmount -
                  vehicleInfo.Reference.ID
                ).toString(),
            isYoungDriverAge: reservationInfo.isYoungDriverAge,
            isYoungDriver2Age: reservationInfo.isYoungDriver2Age,
            youngDriver2Fee: vehicleInfo.youngDriver2Fee,
            youngDriverFee2Desc: vehicleInfo.youngDriverFee2Desc,
            youngDriverFee2Code: vehicleInfo.youngDriverFee2Code,
            isSeniorDriverAge: reservationInfo.isSeniorDriverAge,
            noFeeAge: reservationInfo.noFeeAge,
            noAgeFeeDesc: vehicleInfo.noAgeFeeDesc,
            noAgeFeeCode: vehicleInfo.noAgeFeeCode,
            seniorDriverFee: vehicleInfo.seniorDriverFee,
            seniorDriverFeeDesc: vehicleInfo.seniorDriverFeeDesc,
            seniorDriverFeeCode: vehicleInfo.seniorDriverFeeCode,
            youngDriverFee: vehicleInfo.youngDriverFee,
            youngDriverFeeDesc: vehicleInfo.youngDriverFeeDesc,
            youngDriverFeeCode: vehicleInfo.youngDriverFeeCode,
            onRequest: onRequest,
            reservationInfo: {
              endDate:
                DateFns.format(
                  reservationInfo.dropOffDateAndTime,
                  "yyyy-MM-dd"
                ) +
                "T" +
                DateFns.format(reservationInfo.dropOffDateAndTime, "HH:mm:ss"),
              startDate:
                DateFns.format(
                  reservationInfo.pickUpDateAndTime,
                  "yyyy-MM-dd"
                ) +
                "T" +
                DateFns.format(reservationInfo.pickUpDateAndTime, "HH:mm:ss"),
              pickUpLocation: reservationInfo.pickUpLocationDetails.code,
              dropOffLocation: reservationInfo.dropOffLocationDetails.code,
              bookingChannel: reservationInfo.reservationSource.code,
            },

            customerInfo: (() => {
              const {
                firstName: _fn,
                lastName: _ln,
                ...formattedRest
              } = formatUserDetails(updatedCustomerInfo);
              return {
                ...formattedRest,
                firstName: clientId ? "" : firstName || _fn,
                lastName: clientId ? "" : lastName || _ln,
                email: email || updatedCustomerInfo.email,
                telephone: phoneNo || updatedCustomerInfo.telephone,
                country: updatedCustomerInfo.country,
                zip: updatedCustomerInfo.zip,
                isDriver: false,
                clientId: Number(clientId || ""),
                ...(CustomerType === "Private" &&
                  customerDOB &&
                  !isNaN(new Date(customerDOB).getTime()) && {
                    dateOfBirth: new Date(customerDOB).toISOString(),
                  }),
              };
            })(),
            vehicleInfo: {
              VehicleCode: vehicleInfo.Vehicle?.Code,
            },
            paymentMethod: paymentMethod,
            insuranceId: selectedInsurance?.toString(),
            Fee: {
              Amount: !paymentInfo.extrasIncluded
                ? (
                    paymentInfo.price +
                    extrasPrice +
                    parseFloat(paymentInfo.surchargeAmt ?? "0")
                  )?.toString()
                : (
                    paymentInfo.price +
                    parseFloat(paymentInfo.surchargeAmt ?? "0")
                  ).toString(),
              CurrencyCode: "EUR",
            },
            isEndUserBooking: "true", // to be enabled if payment method is not wiretransfer,
            onlineUser: { id: userId },
            bookingLang: i18n.language,
            payWiretransfer: payWiretransfer, // for MRent
            payVpos: payVpos, // for MRent
            CompanyInfo: {
              CompanyPhoneNumber: CompanyInfo?.CompanyPhoneNumber,
              CompanyEmail: CompanyInfo?.CompanyEmail,
              CompanyEInvoicingCode: CompanyInfo?.CompanyEInvoicingCode
                ? CompanyInfo?.CompanyEInvoicingCode
                : "",
              CompanyEInvoicingEmail: CompanyInfo?.CompanyEInvoicingEmail,
              CompanyBirthDate: CompanyInfo?.birthDate
                ? new Date(companyDOB).toISOString()
                : CompanyInfo.birthDate,
              CompanyBirthCity: CompanyInfo?.city,
              CompanyBirthProv: CompanyInfo?.CompanyBirthProv,
              CompanyBirthCountry: CompanyInfo?.country,
              CompanyStreet: CompanyInfo?.CompanyStreet,
              CompanyStreetNumber: CompanyInfo?.CompanyStreetNumber,
              CompanyCityName: CompanyInfo?.city,
              CompanyPostalCode: CompanyInfo?.CompanyPostalCode,
              CompanyStateProv: CompanyInfo?.CompanyBirthProv,
              CompanyCountry: CompanyInfo?.country,
              CompanyName: CompanyInfo?.CompanyName,
              CompanyVatNumber: CompanyInfo?.CompanyVatNumber,
              CustomerType: CustomerType,
              CompanyTaxCode: companySSn,
              IndividualFirstName: CompanyInfo?.firstName,
              IndividualLastName: CompanyInfo?.lastName,
              gender:
                normalizeGender(CompanyInfo?.gender) === "MALE"
                  ? true
                  : normalizeGender(CompanyInfo?.gender) === "FEMALE"
                  ? false
                  : null,
            },
            optionals: Object.values(extrasSelected).map((e) => {
              return {
                Equiptype: e.name,
                Quantity: e.quantity.toString(),
                price: parseInt(e.price.toString()),
              };
            }),
            enableCreditCardDeferredPayment: enableCreditCardDeferredPayment,
            deliverySurchargeAmount:
              vehicleInfo.deliverySurchargeAmount != null
                ? parseFloat(vehicleInfo.deliverySurchargeAmount.toFixed(2))
                : null,
            returnSurchargeAmount:
              vehicleInfo.returnSurchargeAmount != null
                ? parseFloat(vehicleInfo.returnSurchargeAmount.toFixed(2))
                : null,
            homeDeliveryAddress: reservationInfo.homeDeliveryAddress || null,
            homeDeliveryAddressKm:
              reservationInfo.homeDeliveryAddressKm ?? null,
            homeReturnAddress: reservationInfo.homeReturnAddress || null,
            homeReturnAddressKm: reservationInfo.homeReturnAddressKm ?? null,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
            },
            withCredentials: true,
          }
        );
      } else {
        return "invalid.company.vat";
      }
    } else if (isValidSSN == "Invalid TaxCode") {
      return "invalid.customer.ssn";
    } else {
      return "invalid.companyTaxCode";
    }
  }

  async getBookingFilterMethods(): Promise<AxiosResponse> {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 + "/reservations/getBookingFilterList",
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getVoucherWithScript(voucher: string) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 + `/reservations/checkVoucherCode`,
      {
        params: {
          voucherCode: voucher,
        },
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getExistingCustomerRAInv(taxOrVatNumber: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post(
      process.env.REACT_APP_SERVER_URL_2 + `/customer/existingCutomerInvoice`,
      { vatNumberOrTaxCode: taxOrVatNumber },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async getBookingAgeCriteria(locationLang: string) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/getBookingAgeCriteria?language=${locationLang}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  getAllNewPaymentMethods(selectedAffiliate: string) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios
      .get<NewPaymentsMethods>(
        `${process.env.REACT_APP_SERVER_URL_2}/settings/bookingPayments?affiliate=${selectedAffiliate}&language=${i18n.language}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  async validateSSNField(
    customerInfo: DetailsFormValues,
    firstName,
    lastName,
    country?: Array<{ EN: string; IT: string; SELECT: string }>,
    paymentTypeCompanyDetails,
    hideNumberOfFieldsAtPayAtDesk
  ) {
    const currentTime = new Date();
    const dobDatePart = new Date(customerInfo.dateOfBirth);
    dobDatePart.setHours(currentTime.getHours());
    dobDatePart.setMinutes(currentTime.getMinutes());
    dobDatePart.setSeconds(currentTime.getSeconds());
    dobDatePart.setMilliseconds(currentTime.getMilliseconds());
    const hashedToken = this.encryptToken(this.token_value);

    const updatedCustomerInfo = { ...customerInfo };
    const skipSsnValidation =
      paymentTypeCompanyDetails == "payLater" && hideNumberOfFieldsAtPayAtDesk;
    // sex and dob are required by the API — skip if either is missing
    const hasSex = !!customerInfo?.sex;
    const hasDob = !!customerInfo?.dateOfBirth;
    if (
      customerInfo.country?.toLowerCase().includes("ital") &&
      !skipSsnValidation &&
      hasSex &&
      hasDob
    ) {
      let sourceList;
      if (country && country.length > 0) {
        sourceList = country;
      } else if (
        countryList &&
        countryList.country &&
        countryList.country.length > 0
      ) {
        sourceList = countryList.country;
      } else {
        sourceList = [];
      }

      // Try to find the country by EN name in the countryList
      const selectedCountry = sourceList.find(
        (item) =>
          item.EN?.toLowerCase() === customerInfo?.country?.toLowerCase() ||
          item.IT?.toLowerCase() === customerInfo?.country?.toLowerCase()
      );

      if (selectedCountry) {
        updatedCustomerInfo.country = selectedCountry.SELECT;
      }
      const genderValue = normalizeGender(customerInfo?.sex);
      return await this.bookingApiRequestInstance
        .post<SsnByItalianCustomerDetails>(
          process.env.REACT_APP_SERVER_URL_2 + "/customer/details_by_ssn",
          {
            firstName: firstName,
            lastName: lastName,
            birthNation: customerInfo.birthNation,
            birthPlace: customerInfo.birthPlace,
            sex: genderValue,
            dob: customerInfo.dateOfBirth
              ? new Date(dobDatePart).toISOString()
              : "",

            national: updatedCustomerInfo.country,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
            },
            withCredentials: true,
          }
        )
        .then((e) => {
          const data = e.data || "";
          if (
            data.toString().toLowerCase() !==
            customerInfo?.ssnNumber?.toString().toLowerCase()
          ) {
            return "Invalid TaxCode";
          } else {
            return "true";
          }
        });
    } else {
      return "true";
    }
  }

  async validateSSNFieldForCompany(
    companyInfo: companyDetails,
    ssn,
    paymentTypeCompanyDetails,
    hideNumberOfFieldsAtPayAtDesk
  ) {
    const currentTime = new Date();
    const dobDatePart = new Date(companyInfo.birthDate);
    dobDatePart.setHours(currentTime.getHours());
    dobDatePart.setMinutes(currentTime.getMinutes());
    dobDatePart.setSeconds(currentTime.getSeconds());
    dobDatePart.setMilliseconds(currentTime.getMilliseconds());
    const hashedToken = this.encryptToken(this.token_value);
    const skipSsnValidation =
      paymentTypeCompanyDetails == "payLater" && hideNumberOfFieldsAtPayAtDesk;
    const hasSex = !!companyInfo.gender;
    const hasDob = !!companyInfo.birthDate;
    if (
      companyInfo.country?.toLowerCase().includes("ital") &&
      !skipSsnValidation &&
      hasSex &&
      hasDob
    ) {
      return await this.bookingApiRequestInstance
        .post<SsnByItalianCustomerDetails>(
          process.env.REACT_APP_SERVER_URL_2 + "/customer/details_by_ssn",
          {
            firstName: companyInfo.firstName,
            lastName: companyInfo.lastName,
            birthNation: companyInfo.birthNation,
            birthPlace: companyInfo.birthPlace,
            sex: normalizeGender(companyInfo.gender),
            dob: companyInfo.birthDate
              ? new Date(dobDatePart).toISOString()
              : "",
            national: companyInfo.country,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
            },
            withCredentials: true,
          }
        )
        .then((e) => {
          const data = e.data || "";
          if (data.toString() !== ssn) {
            return "Invalid CompanyTaxCode";
          } else {
            return "true";
          }
        });
    } else {
      return "true";
    }
  }

  async validateVATNumber(CompanyInfo: companyDetails) {
    const country = CompanyInfo.country?.toUpperCase();
    const birthNation = CompanyInfo.birthNation?.toUpperCase();
    if (
      (!birthNation && country !== "ITALIA") ||
      (birthNation && birthNation !== "ITALIA")
    ) {
      // if (CompanyInfo.birthNation !== "ITALIA") {
      return true;
    } else {
      const hashedToken = this.encryptToken(this.token_value);

      return await this.bookingApiRequestInstance
        .post<SsnByItalianCustomerDetails>(
          process.env.REACT_APP_SERVER_URL_2 + "/customer/validateVatApi",
          {
            vatNumber: CompanyInfo.CompanyVatNumber,
            country: CompanyInfo.country,
          },
          {
            headers: {
              Authorization: `Bearer ${hashedToken}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
            },
            withCredentials: true,
          }
        )
        .then((e) => {
          const data = e.data || "";
          if (data.toString() === "true") {
            return true;
          } else {
            return false;
          }
        });
    }
  }

  getPaymentLink(
    reservationId: number,
    amount: number,
    paymentMode: string,
    bookingDetails?: PaymentBodyForScalapay,
    isChargeOrDep: "C" | "D" = "C"
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    const amountTillTwoDecimal = amount.toFixed(2);
    return axios
      .post<PaymentLinkResponse>(
        process.env.REACT_APP_SERVER_URL_2 +
          `/settings/paymentLink/${reservationId}/${amountTillTwoDecimal}`,
        {
          bookingDetails,
          paymentMode,
          isChargeOrDep,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  fetchStripePaymentDetailsAndConfig(
    isChargeOrDep: "C" | "D",
    amount: string,
    reservationId: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .post<Record<string, any>>(
        process.env.REACT_APP_SERVER_URL_2 +
          `/settings/stripe/create-payment-details-config`,
        { isChargeOrDep, amount, reservationId },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => e.data);
  }

  saveStripeDirectPaymentDetails(body: {
    payment_intent_id: string;
    client_secret: string;
    total_amount: string;
    amount_received: string;
    payment_method_type: string;
    payment_date: string;
    rental_id: string;
    reservation_id: string;
    payment_intent_status: string;
    payment_status: string;
    currency: string;
    isCharge: string;
    isDeposit: string;
    price_id: string;
  }) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .post<Record<string, any>>(
        process.env.REACT_APP_SERVER_URL_2 +
          `/settings/stripe/save-payment-details`,
        body,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => e.data);
  }

  getAppSetting() {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<AppSettingResponse>(
        process.env.REACT_APP_SERVER_URL_2 + `/settings/app`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  createNewUser(e, requireManualApproval) {
    const hashedToken = this.encryptToken(this.token_value);
    const isCompany = e.isPhysicalPerson === false;
    const onlineUserStatus = requireManualApproval ? "PENDING" : "ACTIVE";

    return axios
      .post(
        process.env.REACT_APP_SERVER_URL_2 + "/customer/registerBookingUser",
        {
          firstName: e.firstName,
          lastName: e.lastName,
          phoneNumber: e.phoneNumber,
          email: e.email.toLowerCase(),
          password: this.encryptLoginPayload(e.password),
          birthDate: e.birthDate,
          onlineUserType: isCompany ? "Company" : "EndUser",
          onlineUserRole: isCompany ? "Manager" : "Operator",
          onlineUserStatus,
          ...(e.companyName && { companyName: e.companyName }),
          ...(e.vatNumber && { vatNumber: e.vatNumber }),
          ...(e.isPhysicalPerson !== undefined && {
            isPhysicalPerson: e.isPhysicalPerson,
          }),
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then(function (response) {
        return response;
      });
  }

  loginUser(e) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .post(
        process.env.REACT_APP_SERVER_URL_2 + "/customer/login",
        {
          email: e.email.toLowerCase(),
          password: this.encryptLoginPayload(e.password),
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then(function (response) {
        localStorage.setItem("userAffiliate", response?.data?.user?.affiliate);
        return response;
      });
  }

  getBookingDetailsbyUserId(userid: number, offset: number, max: number) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/bookinglist/by/userid/${userid}/reservation/${offset}/${max}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getRentalDetailsbyUserId(userId: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/getRentalsForOnlineUser/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getLastBookingDetail(userId: number) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/getLastBookingDetails/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getOnlineUserInvoices(userId: number, offset: number, max: number) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/getInvoiceListForOnlineUser/${userId}/${offset}/${max}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  downloadInvoice(invoiceId: number) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/downloadInvoice/${invoiceId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  // UpdateUserProfileById(id, e) {
  //   const hashedToken = this.encryptToken(this.token_value);

  //   return axios.post(
  //     process.env.REACT_APP_SERVER_URL_2 +
  //       `/customer/onlineUser/updateOnlineUser/${id}`,
  //     {
  //       firstName: e.firstName,
  //       lastName: e.lastName,
  //       phoneNumber: e.phoneNumber,
  //       userImage: e.userImage,
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer ${hashedToken}`,
  //         "Cache-Control": "no-cache",
  //         Pragma: "no-cache",
  //         Expires: "0",
  //         "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
  //       },
  //       withCredentials: true,
  //     }
  //   );
  // }
  UpdateUserProfileById(id, userDetails) {
    const formData = new FormData();
    // Append JSON data string
    formData.append(
      "jsonData",
      JSON.stringify({
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        phoneNumber: userDetails.phoneNumber,
        companyName: userDetails.companyName,
        vatNumber: userDetails.vatNumber,
      })
    );

    // Check if profile_picture exists and is a valid file
    if (userDetails.profile_picture) {
      formData.append("file", userDetails.profile_picture);
    }
    const hashedToken = this.encryptToken(this.token_value);

    return axios
      .post(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/onlineUser/updateDetailsAndProfilePicture/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      .then((res) => res.data);
  }

  getUserProfileByUserId(userid: number) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 + `/customer/getUserProfile/${userid}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async getCustomerDeatilsByUserid(
    userid: number,
    offset: number,
    max: number
  ) {
    const hashedToken = this.encryptToken(this.token_value);

    return await this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/onlineUser/${userid}/customer/${offset}/${max}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  async updateCustomerDetailByCustomerId(id, cid, data) {
    const hashedToken = this.encryptToken(this.token_value);

    const headers = {
      Authorization: `Bearer ${hashedToken}`,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
      "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_SERVER_URL_2}/customer/${id}/${cid}`,
        {
          firstName: data.firstName,
          middleName: data.middleName,
          lastName: data.lastName,
          companyName: data.companyName,
          mobileNumber: data.mobileNumber,
          email: data.email,
          country: data.country,
          state: data.state,
          city: data.city,
          streetName: data.street,
          streetNumber: data.streetNumber,
          zip: data.zip,
          vatNumber: data.vatNumber,
          ssnNumber: data.ssnNumber,
          sex: data.sex,
          telephone: data.telephone,
          dateOfBirth: data.dateofBirth,
          birthPlace: data.birthPlace,
          birthProvince: data.birthProvidence,
          birthNation: data.birthNation,
          isDriver: data.isDriver,
          license: data.licence,
          issuedBy: data.issuedBy,
          releaseDate: data.releaseDate,
          licenseType: data.licenceType,
          documentIssueDate: data.documentIssueDate,
          documentExpiryDate: data.documentExpiryDate,
          documentNumber: data.documentNumber,
          document: data.document,
          customerId: data.customerId,
          customerType: data.customerType,
        },
        {
          headers: headers,
          withCredentials: true,
        }
      );
      return response;
    } catch (error) {
      console.error("Error updating customer details:", error);
      throw error;
    }
  }

  async sentVerificationcode(e) {
    const hashedToken = this.encryptToken(this.token_value);

    return await axios
      .post(
        process.env.REACT_APP_SERVER_URL_2 + `/customer/login/sendVerification`,
        {
          email: e,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }
  async forgotPassword(otp) {
    const hashedToken = this.encryptToken(this.token_value);

    return await axios
      .post(
        process.env.REACT_APP_SERVER_URL_2 +
          `/customer/login/verifyOtpChangePassword`,
        {
          verificationCode: otp.verificationCode,
          emailId: otp.email,
          newPassword: this.encryptLoginPayload(otp.newPassword),
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }

  async changePassword(data) {
    const hashedToken = this.encryptToken(this.token_value);

    const id: any = localStorage.getItem("userID");
    return await axios
      .post(
        process.env.REACT_APP_SERVER_URL_2 +
          `/customer/changePasswordForOnlineUser/${id}`,
        {
          oldPassword: data.oldPassword,
          newPassword: data.newPassword,
          confirmPassword: data.confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      })
      .catch((err) => {
        return err;
      });
  }

  getInsuranceDetails(
    reservationDetails: BookingDetails,
    vehicleGroup: string,
    allVehicleAllOptions: OptionInVehicle[]
  ) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios
      .post<InsuranceDetails>(
        process.env.REACT_APP_SERVER_URL_2 +
          `/reservations/touroperator/getInsuranceList?language=${i18n.language}`,
        {
          startDate: reservationDetails.pickUpDateAndTime,
          endDate: reservationDetails.dropOffDateAndTime,
          reservationSource:
            reservationDetails.reservationSource.code || "WEB001",
          group: vehicleGroup,
          locationCode: reservationDetails.pickUpLocationDetails.code,
          extras: allVehicleAllOptions?.map((e) => {
            return {
              code: e.Equipment.EquipType,
              amount: e.Charge.Amount,
            };
          }),
        },
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        e.data["Booking Insurance"] = (e.data["Booking Insurance"] ?? []).sort(
          (o1, o2) => {
            return o1.Amount - o2.Amount;
          }
        );
        return e.data;
      });
  }
  sendEmailForWireTransfer(
    id: number,
    onRequest: string,
    language: string,
    userId: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/touroperator/${id}/sendEmail`,
      {
        onRequest: onRequest,
        language: language,
        userId: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  savePaymentForNexi(paymentDetails: NexiChargeTransactionDetails) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 + `/reservations/handlePayments`,
      {
        ...paymentDetails,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
  sendScalapayTransactionDetails(orderToken) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/handleScalapayPayments`,
      {
        orderToken,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  sendPayPalTransactionDetails(orderId) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 + `/reservations/handlePaypalPayments`,
      {
        orderId,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  savePaymentForStripe(paymentDetails: StripeTransactionDetails) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 + `/reservations/handlePayments1`,
      {
        ...paymentDetails,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getPrivacyAndTerms() {
    const hashedToken = this.encryptToken(this.token_value);

    return axios
      .get<PrivacyTerms>(
        process.env.REACT_APP_SERVER_URL_2 +
          "/reservations/touroperator/getPrivacyAndTerms/" +
          i18n.language,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  getResPrint(id: string, lang: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios
      .get<AxiosResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/getResPrint/${id}?language=${lang}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        return e.data;
      });
  }
  getVoucherPrint(id: string, lang: string) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios
      .get<AxiosResponse>(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/getVoucherPrint/${id}?language=${lang}`,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      )
      .then((e) => {
        console.log("voucher print data", e.data);
        return e.data;
      });
  }

  async getTextResource(lang: string) {
    const hashedToken = this.encryptToken(this.token_value);

    const response = await axios.get<AxiosResponse>(
      `${process.env.REACT_APP_SERVER_URL_2}/settings/getTextResource/${lang}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
    return response;
  }
  cancelBooking(
    prefix: string,
    number: string,
    codice: string,
    cancelReason: string,
    reservationSourceCode: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 + "/reservations/cancelBooking",
      {
        prefix: prefix.toString(),
        number: number.toString(),
        codice: codice.toString(),
        cancelReason: cancelReason.toString(),
        channel: reservationSourceCode.toString(),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  couponDiscount(
    couponCode: string,
    startDate: string,
    endDate: string,
    rateAmount: string,
    optionalAmount: string,
    totalAmount: string,
    refIdContext: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);

    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 + "/reservations/couponDiscount",
      {
        couponCode: couponCode.toString(),
        startDate: startDate.toString(),
        endDate: endDate.toString(),
        rateAmount: rateAmount.toString(),
        optionalAmount: optionalAmount.toString(),
        totalAmount: totalAmount.toString(),
        refIdContext: refIdContext.toString(),
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  getReservationSourceForOnlineUser(userId: number) {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/getReservationSourceForOnlineUser/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  fetchTheme() {
    const hashedToken = this.encryptToken(this.token_value);

    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/fetchDynamicThemePalette`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  checkIfCustomerIsBlacklisted(vatNumberOrTaxCode: string | number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/customer/checkIfCustomerIsBlacklisted/${vatNumberOrTaxCode}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async uploadVoucherAndGetResDetails(file: File, data?: any): Promise<any> {
    const formData = new FormData();
    formData.append("file", file);
    if (data) {
      formData.append("data", JSON.stringify(data));
    }

    const hashedToken = this.encryptToken(this.token_value);
    try {
      return axios.post(
        process.env.REACT_APP_SERVER_URL_2 +
          "/reservations/getResDetailFromDocs",
        formData,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error uploading voucher:", error);
      throw error;
    }
  }

  async uploadDocumentsAndGetCusDetails(file: File, data?: any): Promise<any> {
    const formData = new FormData();
    formData.append("file", file);
    if (data) {
      formData.append("data", JSON.stringify(data));
    }

    const hashedToken = this.encryptToken(this.token_value);
    try {
      return axios.post(
        process.env.REACT_APP_SERVER_URL_2 +
          "/reservations/getCustomerDataFromImage",
        formData,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error uploading voucher:", error);
      throw error;
    }
  }

  webCheckinConfirmation(
    bookingId: number,
    onRequest: string,
    language: string
  ) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/touroperator/${bookingId}/webCheckinConfirmation`,
      {
        onRequest: onRequest,
        language: language,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  // getCargosCity(city: string, nation: string) {
  //   const hashedToken = this.encryptToken(this.token_value);
  //   return axios.get(
  //     process.env.REACT_APP_SERVER_URL_2 +
  //       `/reservations/touroperator/getCargosCity?city=${city}&nation=${nation}`,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${hashedToken}`,
  //         "Cache-Control": "no-cache",
  //         Pragma: "no-cache",
  //         Expires: "0",
  //         "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
  //       },
  //       withCredentials: true,
  //     }
  //   );
  // }

  isInvoiceCreated(vatNumberOrTaxCode: string) {
    const hashedToken = this.encryptToken(this.token_value);
    return axios.get(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/touroperator/isInvoiceCreated?vatNumberOrTaxCode=${vatNumberOrTaxCode}`,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  archiveCustomer(existingCustomerId: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/touroperator/archiveCustomer`,
      { existingCustomerId: existingCustomerId },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  async insertNewCustomer(
    reservationId: number,
    customerDetails: DetailsFormValues
  ): Promise<AxiosResponse<any>> {
    const { reservationVoucher, ...safeCustomerDetails } =
      customerDetails as any;
    const hashedToken = this.encryptToken(this.token_value);

    const payload = {
      reservationId: String(reservationId),
      firstName: safeCustomerDetails.firstName || "",
      lastName: safeCustomerDetails.lastName || "",
      middleName: safeCustomerDetails.middleName || null,
      ragioneSociale: safeCustomerDetails.companyName || null,
      codice: safeCustomerDetails.codice || null,
      street:
        safeCustomerDetails.streetName || safeCustomerDetails.address || "",
      num: safeCustomerDetails.streetNumber || null,
      city: safeCustomerDetails.city || null,
      zip: safeCustomerDetails.zip?.toString() || null,
      country: safeCustomerDetails.country || "",
      state: safeCustomerDetails.state || null,
      phNum1: safeCustomerDetails.phNum1 || safeCustomerDetails.telephone || "",
      phNum2: safeCustomerDetails.phNum2 || null,
      mobileNumber: safeCustomerDetails.mobileNumber || null,
      email: safeCustomerDetails.email || "",
      vatNumber: safeCustomerDetails.vatNumber || null,
      birthPlace: safeCustomerDetails.birthPlace || null,
      birthDate: safeCustomerDetails.dateOfBirth || null,
      birthProvince: safeCustomerDetails.birthProvince || null,
      birthNation: safeCustomerDetails.birthNation || null,
      gender:
        safeCustomerDetails.sex === "MALE"
          ? true
          : safeCustomerDetails.sex === "FEMALE"
          ? false
          : null,
      taxCode: safeCustomerDetails.ssnNumber || null,
      document: safeCustomerDetails.document || null,
      documentNumber: safeCustomerDetails.documentNumber || null,
      document2: safeCustomerDetails.document1 || null,
      documentNumber2: safeCustomerDetails.documentNumb1 || null,
      licenceType: safeCustomerDetails.licenseType || null,
      issueBy: safeCustomerDetails.issueBy || null,
      issueBy2: safeCustomerDetails.issueBy1 || null,
      releaseDate: safeCustomerDetails.releaseDate || null,
      releaseDate2: safeCustomerDetails.releaseDate1 || null,
      expiryDate: safeCustomerDetails.documentExpiryDate || null,
      expiryDate2: safeCustomerDetails.expiryDate1 || null,
      customerType: safeCustomerDetails.customerType || null,
      isPhysicalPerson: safeCustomerDetails.isCustPhysicalPerson || null,
      isIndividualCompany: safeCustomerDetails.isCustIndividualCompany || null,
    };

    try {
      return this.bookingApiRequestInstance.post(
        `${process.env.REACT_APP_SERVER_URL_2}/reservations/touroperator/insertNewCustomer`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${hashedToken}`,
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error inserting new customer:", error);
      throw error;
    }
  }

  updateSpecificDriver(
    reservationId: number,
    driverNumber: number,
    driverDetails: DetailsFormValues,
    country?: Array<{ EN: string; IT: string; SELECT: string }>
  ): Promise<AxiosResponse<CustomerDetailsResponse_2>> {
    const temp: Record<string, any> = { ...driverDetails };
    for (const i of Object.keys(temp)) {
      if (!temp[i]) {
        delete temp[i];
      }
      if (
        i === "customerDocs" ||
        i === "issueBy" ||
        i === "documents" ||
        i === "identificationDocuments" ||
        i === "drivingLicenseDocuments"
      ) {
        delete temp[i];
      }
    }

    const sourceList: Array<{ EN: string; IT: string; SELECT: string }> =
      country && country.length > 0
        ? country
        : countryList?.country?.length > 0
        ? countryList.country
        : [];

    const selectedCountry = sourceList.find(
      (item) => item.EN === temp.country || item.IT === temp.country
    );
    if (selectedCountry) {
      temp.country = selectedCountry.SELECT;
    }

    const issuedBy = (driverDetails as any).issueBy || "";
    const payload = {
      ...temp,
      zip: temp.zip?.toString() || "",
      isDriver: (temp.isDriver || "").toLowerCase() === "yes",
      customerType: (temp.customerType || "").toUpperCase(),
      issuedBy,
    };

    const hashedToken = this.encryptToken(this.token_value);
    const headers = {
      Authorization: `Bearer ${hashedToken}`,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
      "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
    };

    return axios
      .post<CustomerDetailsResponse_2>(
        `${process.env.REACT_APP_SERVER_URL_2}/driver/add/reservation/${reservationId}/driverNumber/${driverNumber}`,
        payload,
        { headers, withCredentials: true }
      )
      .then((response) => {
        const newCustomerId = response.data?.customerId;
        if (newCustomerId) {
          const { identificationDocuments, drivingLicenseDocuments } =
            driverDetails as any;
          if (
            (identificationDocuments && identificationDocuments.length) ||
            (drivingLicenseDocuments && drivingLicenseDocuments.length)
          ) {
            const formData = new FormData();
            (identificationDocuments || []).forEach((el: File) =>
              formData.append("idDoc", el)
            );
            (drivingLicenseDocuments || []).forEach((el: File) =>
              formData.append("driverLicenseDocument", el)
            );
            this.bookingApiRequestInstance
              .post(
                `${process.env.REACT_APP_SERVER_URL_2}/driver/upload-documents-vrent/${newCustomerId}`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${hashedToken}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
                  },
                  withCredentials: true,
                }
              )
              .catch((err) =>
                console.error("Document upload failed for new driver:", err)
              );
          }
        }
        return response;
      });
  }

  reservationSetCustomerAsDriver1(reservationId: number) {
    const hashedToken = this.encryptToken(this.token_value);
    return this.bookingApiRequestInstance.post(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/reservationSetCustomerAsDriver1`,
      { reservationId: reservationId },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  // async createOnlineuserCustomer(e: any): Promise<AxiosResponse<any>> {
  //   const hashedToken = this.encryptToken(this.token_value);
  //
  //   const payload = {
  //     companyName: e.companyName || null,
  //     vatNumber: e.vatNumber || null,
  //     mobileNumber: e.mobileNumber || null,
  //     email: e.email || "",
  //     isPhysicalPerson: e.isPhysicalPerson ?? false,
  //     isClient: e.isClient ?? true,
  //     isSupplier: e.isSupplier ?? false,
  //     isDriver: e.isDriver ?? false,
  //   };
  //
  //   return this.bookingApiRequestInstance.post(
  //     `${process.env.REACT_APP_SERVER_URL_2}/customer/createOnlineuserCustomer`,
  //     payload,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${hashedToken}`,
  //         "Content-Type": "application/json",
  //         "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
  //       },
  //       withCredentials: true,
  //     }
  //   );
  // }

  async createOnlineuserCustomer(e: any): Promise<AxiosResponse<any>> {
    const hashedToken = this.encryptToken(this.token_value);

    const payload = {
      onlineUserID: e.onlineUserID,
      isPhysicalPerson: e.isPhysicalPerson ?? false,
      isClient: e.isClient ?? true,
      isSupplier: e.isSupplier ?? false,
      isDriver: e.isDriver ?? false,
      // Personal fields
      firstName: e.firstName || null,
      lastName: e.lastName || null,
      email: e.email || "",
      mobileNumber: e.mobileNumber || null,
      birthDate: e.birthDate || null,

      // Company fields
      companyName: e.companyName || null,
      vatNumber: e.vatNumber || null,
    };

    return this.bookingApiRequestInstance.post(
      `${process.env.REACT_APP_SERVER_URL_2}/customer/createOnlineuserCustomer`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }

  sendRegistrationEmail(
    onlineUserId: string,
    onRequest: string,
    language: string
  ) {
    console.log("inside sendRegistrationEmail");
    const hashedToken = this.encryptToken(this.token_value);
    return axios.post(
      process.env.REACT_APP_SERVER_URL_2 +
        `/reservations/touroperator/sendRegistrationEmail`,
      {
        onlineUserId: onlineUserId,
        onRequest: onRequest,
        language: language,
      },
      {
        headers: {
          Authorization: `Bearer ${hashedToken}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "X-XSRF-TOKEN": getCookie("XSRF-TOKEN") || "",
        },
        withCredentials: true,
      }
    );
  }
}
function formatUserDetails(
  customerInfo: DetailsFormValues
): Record<string, any> {
  const tempCustomerInfo: Record<string, any> = { ...customerInfo };
  for (const i in tempCustomerInfo) {
    if (tempCustomerInfo[i] == "") {
      delete tempCustomerInfo[i];
    }

    // else if (i == "zip" && tempCustomerInfo[i]) {
    //   tempCustomerInfo[i] = parseInt((tempCustomerInfo[i] || "").toString());
    // }
    else if (i == "ssnNumber" && tempCustomerInfo[i]) {
      tempCustomerInfo[i] = (tempCustomerInfo[i] || "").toString();
    }
    if (i == "customerDocs") {
      delete tempCustomerInfo[i];
    }
  }
  return tempCustomerInfo;
}

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift() || null;
  }
  return null;
}

const BookingApiInstance: BookingApi = new BookingApi();
export { BookingApiInstance as default, BookingApiInstance as BookingApi };
